module.exports = __webpack_public_path__ + "static/semantic-placeholder-content-paragraph-676058f92ae0042b6a72339dfca69b7e.gif";